<template>
  <div v-if="showPopup" id="popup-container" :class="$style.popup">
    <div :class="$style.cover"></div>
    <div :class="$style.popup_box">
      <div id="popup-wrapper" :class="$style.wrapper">
        <p
          v-if="msg.title"
          :class="$style.title"
          :style="msg.titleStyle ? msg.titleStyle : ''"
          :title="msg.title"
        >
          {{ msg.title }}
          <i v-if="msg.close" @click="cancel">&#10006;</i>
        </p>
        <div :class="$style.text" v-html="msg.text"></div>
        <div :class="$style.btnPanel" :style="msg.btnStyle.panel">
          <span
            v-if="msg.btn.cancel"
            :class="$style.btnItem"
            :style="
              Object.keys(msg.btnStyle.cancel).length
                ? msg.btnStyle.cancel
                : defaulCss
            "
          >
            <span
              :class="[$style.btn, $style.cancel]"
              :style="{ width: btns === 1 ? '100%' : '' }"
              @click="cancel"
              >{{ msg.btn.cancel }}</span
            >
          </span>
          <span
            v-if="msg.btn.apply"
            :class="$style.btnItem"
            :style="
              Object.keys(msg.btnStyle.apply).length
                ? msg.btnStyle.apply
                : defaulCss
            "
          >
            <span
              :class="[$style.btn, $style.apply]"
              :style="{ width: btns === 1 ? '100%' : '' }"
              @click="apply"
              >{{ msg.btn.apply }}</span
            >
          </span>
          <span
            v-if="msg.btn.confirm"
            :class="$style.btnItem"
            :style="
              Object.keys(msg.btnStyle.confirm).length
                ? msg.btnStyle.confirm
                : defaulCss
            "
          >
            <span
              :class="[$style.btn, $style.confirm]"
              :style="{ width: btns === 1 ? '100%' : '' }"
              @click="confirm"
              >{{ msg.btn.confirm }}</span
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Popup',
  data() {
    return {
      defaulCss: {
        width: '100%',
      },
      btns: 1,
      showPopup: true,
      msg: {
        position: '',
        title: '',
        titleStyle: {},
        close: false,
        btn: {
          cancel: '',
          apply: '',
          confirm: '',
        },
        btnStyle: {
          cancel: {},
          apply: {},
          confirm: {},
        },
      },
    }
  },
  beforeCreate() {
    var exsistPopupEl = document.getElementById('popup-container')
    if (exsistPopupEl) {
      document.body.removeChild(exsistPopupEl)
    }
  },
  mounted() {
    const _this = this
    setTimeout(() => {
      var wrapperEl = document.getElementById('popup-wrapper')
      var position = 'middle'
      if (typeof _this.msg.position === 'number') {
        position = 'calc(50% - ' + _this.msg.position + 'px)'
      }
      if (
        typeof _this.msg.position === 'string' &&
        (_this.msg.position.indexOf('%') > -1 ||
          _this.msg.position.indexOf('vh') > -1)
      ) {
        position = _this.msg.position
      }
      switch (_this.msg.position) {
        case 'top':
          position = '0px'
          break
        case 'middleTop':
          position = 'calc(50% - ' + wrapperEl.offsetHeight + 'px)'
          break
        case 'middle':
          position = 'calc(50% - ' + wrapperEl.offsetHeight / 2 + 'px)'
          break
        case 'middleBottom':
          position = '50%'
          break
        case 'bottom':
          position = '100%'
          break
      }
      wrapperEl.style.top = position
    }, 10)
  },
  updated() {
    this.btns = this.literal(this.msg.btn)
    if (!this.showPopup) {
      document.body.style.position = '';
      document.body.style.width = '';
    } else {
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }
  },
  methods: {
    cancel() {},
    apply() {},
    confirm() {},
    literal(o) {
      const arr = []
      for (const k in o) {
        if (o[k]) {
          arr.push(o[k])
        }
      }
      return arr.length
    },
    isMobile() {
      return window.innerWidth < 768
    },
  },
}
</script>
<style lang="scss" module>
.popup {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  .cover {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.6;
  }
  .popup_box{
    position: fixed;
    top: 0px;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .wrapper {
    position: fixed;
    // left: 35%;
    width: 30%;
    max-height: 80%;
    padding: 15px;
    overflow: auto;
    background: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    left: 0;
    right: 0;
    margin: auto;
    min-width: 350px;
    .title {
      position: relative;
      height: 35px;
      padding-bottom: 10px;
      font-weight: bold;
      cursor: pointer;
      border-bottom: 1px solid #eee;
      i {
        position: absolute;
        top: -10px;
        right: 0;
        display: inline-block;
        padding: 10px;
      }
    }
    .text {
      max-height: calc(80% - 110px);
      padding: 10px 0;
      overflow-y: auto;
      white-space: pre-wrap;
    }
    .btnPanel {
      margin-top: 10px;
      text-align: center;
      span {
        display: inline-block;
      }
      .btnItem {
        text-align: center;
        .btn {
          box-sizing: border-box;
          width: 90%;
          height: 35px;
          line-height: 35px;
          text-align: center;
          cursor: pointer;
          border: 1px solid #070141;
          border-radius: 5px;
        }
        .cancel {
          color: #070141;
        }
        .confirm {
          color: #fff;
          background: #070141;
        }
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .popup {
    .wrapper {
      // left: 5%;
      width: 90%;
      min-width: none;
    }
  }
}
</style>
